import { Link } from 'react-router-dom';


export default function ArticleSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-[500px]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-3">
              Hipobuy Sheet
              <br />
              <span className="italic font-normal text-foreground-700">Guides &amp; Collections</span>
            </h2>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-[440px]">
            Your complete resource hub for spreadsheet shopping. Built for topical authority — covering every aspect of product discovery, comparison, and smart buying decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/article/hipobuy-spreadsheet-guide"
            className="group relative rounded-lg overflow-hidden bg-foreground-800 p-6 md:p-8 flex flex-col justify-between min-h-[340px] cursor-pointer"
          >
            <div>
              <span className="inline-block px-3 py-1 bg-accent-500/90 text-white text-xs font-label rounded-full mb-4">
                Featured Guide
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-white leading-snug mb-3">
                What Is Hipobuy Sheet?
                <br />
                The Complete 2026 Guide
              </h3>
              <p className="text-white/65 text-sm leading-relaxed line-clamp-4">
                Looking for the most reliable product finder spreadsheet? This in-depth guide covers everything you need to know about Hipobuy Spreadsheet — from how to use it, to safety tips, product categories, and expert comparison strategies. Perfect for beginners and experienced buyers alike.
              </p>
            </div>
            <div className="flex items-center gap-2 mt-6 text-white/70 group-hover:text-white transition-colors">
              <span className="text-sm font-medium">Read Full Guide</span>
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>

          <Link
            to="/article/hipobuy-vs-kakobuy-comparison"
            className="group rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20distinct%20sneaker%20styles%20placed%20side%20by%20side%20on%20a%20light%20stone%20textured%20surface%2C%20subtle%20comparison%20concept%2C%20soft%20morning%20light%20from%20left%2C%20minimal%20studio%20product%20photography%2C%20warm%20beige%20and%20sand%20tones%2C%20elegant%20editorial%20composition%2C%20no%20text%2C%20no%20logos%2C%20peaceful%20and%20clean%20atmosphere&width=800&height=600&seq=comparison-card-v2&orientation=squarish"
                alt="Spreadsheet comparison guide"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-label rounded-full">
                Comparison
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-label text-lg font-semibold text-foreground-900">Hipobuy vs Kakobuy</h3>
              <p className="text-foreground-500 text-sm mt-1">Side-by-side breakdown</p>
              <span className="inline-flex items-center gap-1.5 mt-4 px-4 py-2 bg-foreground-900 text-white text-xs font-medium rounded-full group-hover:bg-foreground-800 transition-colors whitespace-nowrap">
                Read Comparison
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/article/hipobuy-safety-guide"
            className="group rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20shield%20icon%20concept%20depicted%20through%20minimalist%20product%20arrangement%20on%20a%20soft%20ivory%20surface%2C%20protective%20and%20trustworthy%20aesthetic%2C%20gentle%20natural%20lighting%2C%20editorial%20still%20life%20photography%2C%20calm%20reassuring%20tones%2C%20Scandinavian%20design%20influence%2C%20no%20text%2C%20no%20visible%20brands%2C%20serene%20composition&width=800&height=600&seq=safety-card-v2&orientation=squarish"
                alt="Shopping safety guide"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-secondary-500 text-white text-xs font-label rounded-full">
                Safety
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-label text-lg font-semibold text-foreground-900">Safety Guide</h3>
              <p className="text-foreground-500 text-sm mt-1">Shop smart, stay protected</p>
              <span className="inline-flex items-center gap-1.5 mt-4 px-4 py-2 bg-foreground-900 text-white text-xs font-medium rounded-full group-hover:bg-foreground-800 transition-colors whitespace-nowrap">
                Read Safety Guide
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}